// src/pages/manager/sessions/AttendanceMark.jsx
import React from "react";
import MarkAttendance from "../../../components/attendance/MarkAttendance";

const ManagerAttendanceMark = () => {
    return <MarkAttendance role="MANAGER" />;
};

export default ManagerAttendanceMark;
